export default "__VITE_ASSET__f2e05e5b__"